
import linuxDistribution from "../img/blogs/linux.jpg";
import seo from "../img/blogs/seo.jpg";
import sikkim from "../img/blogs/Sikkim.webp";
import cpp from "../img/blogs/cpp.webp";

const blog = [
    {
        id: 1,
        category: 'Medium',
        image: cpp,
        link1: 'https://medium.com/@alpha.sawraj/how-to-reverse-an-array-without-mutating-original-array-71497368a3ce',
        link2: '',
        title: 'How to reverse an array without mutating original array',
        date:   '4 May 2023',
        text: 'There are few solutions that won’t mutate the original array. Let’s take a look'
    },
    {
        id: 2,
        category: 'quora',
        image: sikkim,
        link1: 'https://www.quora.com/profile/Prabhu-Kumar-912',
        link2: '',
        title: 'How do I Plan a solo trip to Sikkim?',
        date:   '17 Sep 2021',
        text: 'Hello My name is Prabhu kumar saw. I’m from a beautiful city Hazaribag.'
    },
    {
        id: 3,
        category: 'Medium',
        image: linuxDistribution,
        link1: 'https://medium.com/@alpha.sawraj/what-is-linux-distribution-with-example-ef918b5d03c6',
        link2: '',
        title: 'What is Linux distribution with example?',
        date:   '6 May 2023',
        text: 'Linux is a family of free and open-source software operating systems ...'
    },
    {
        id: 4,
        category: 'Medium',
        image: seo,
        link1: 'https://medium.com/@alpha.sawraj/seo-tips-to-boost-your-organic-rankings-traffic-2e390199a433',
        link2: '',
        title: 'SEO Tips to Boost Your Organic Rankings & Traffic',
        date:   '10 May 2023',
        text: 'Search engine optimization (SEO) is the practice of increasing the quantity..'
    },
   
   
]

export default blog;